import 'atvImg'
import domtoimage from 'dom-to-image'
import device from './device'

const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
let initAtvImg = () => {
  let $card = $('#contact-us .contact-info-card')
  let $cardParent = $card.parent()
  let width = $card.outerWidth()
  let height = $card.outerHeight()
  $card.css({
    'width': width*2,
    'height': height*2,
    'font-size': '30px',
    'z-index': 0
  })

  domtoimage.toPng($card.get(0))
    .then((dataUrl) => {
      var img = new Image()
      img.src = dataUrl
      img.setAttribute('id', 'atvimg')
      img.setAttribute('width', '270')
      $cardParent.get(0).appendChild(img)
      $card.hide()
    })
    .then(()=>{
      $('#atvimg').atvImg()
    })
}
let mobileOS = device.getMobileOperatingSystem()
if(isChrome && !mobileOS){initAtvImg()}



/** WEBPACK FOOTER **
 ** assets/javascripts/contact_us.js
 **/